<div class="add-container">
    <div class="d-flex justify-content-between align-items-center">
        <h1 class="add-title m-0 p-0">Info - Document</h1>
        <button type="button" class="action-btn" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <br />
    <mat-divider></mat-divider>
    <br />

    <!-- General -->
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>Categorie</strong></h4>
        <p class="col-md-6">{{ group.category_name ? group.category_name : 'n/a' }}</p>
    </div>
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>Dată creat</strong></h4>
        <p class="col-md-6">{{ group.created_at ? (group.created_at | date:'dd.MM.yyyy':'ro') : 'n/a' }}</p>
    </div>
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>Număr document</strong></h4>
        <p class="col-md-6">{{ group.document_nr ? group.document_nr : 'n/a' }}</p>
    </div>
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>Dată document</strong></h4>
        <p class="col-md-6">{{ group.document_date ? (group.document_date | date:'dd.MM.yyyy':'ro') : 'n/a' }}</p>
    </div>
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>Observații</strong></h4>
        <p class="col-md-6">{{ group.observations ? group.observations : 'n/a' }}</p>
    </div>

    <!-- Administrativ -->
    <ng-container *ngIf="group.category_slug === 'dosar_administrativ'">
        <mat-divider class="my-2"></mat-divider>
        <h4><i class="fa-solid fa-folder-gear"></i> Informații Administrative</h4>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Număr înregistrare</strong></h4>
            <p class="col-md-6">{{ group.metadata.registration_nr ? group.metadata.registration_nr : 'n/a' }}</p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Departament / Serviciu</strong></h4>
            <p class="col-md-6">{{ group.metadata.department ? group.metadata.department : 'n/a' }}</p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Responsabil</strong></h4>
            <p class="col-md-6">{{ group.metadata.responsible_name ? group.metadata.responsible_name : 'n/a' }}</p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Termen limită</strong></h4>
            <p class="col-md-6">{{ group.metadata.deadline ? (group.metadata.deadline | date:'dd.MM.yyyy':'ro') : 'n/a'
                }}</p>
        </div>
    </ng-container>

    <!-- Contractual -->
    <ng-container *ngIf="group.category_slug === 'dosar_contractual'">
        <mat-divider class="my-2"></mat-divider>
        <h4><i class="fa-solid fa-file-contract"></i> Informații Contractuale</h4>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Valoare contract</strong></h4>
            <p class="col-md-6">{{ group.metadata.contract_value ? group.metadata.contract_value : 'n/a' }}</p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Parte contractantă</strong></h4>
            <p class="col-md-6">{{ group.metadata.contracting_party ? group.metadata.contracting_party : 'n/a' }}</p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Tip contract</strong></h4>
            <p class="col-md-6">{{ group.metadata.contract_type ? group.metadata.contract_type : 'n/a' }}</p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Data semnării</strong></h4>
            <p class="col-md-6">{{ group.metadata.signing_date ? (group.metadata.signing_date | date:'dd.MM.yyyy':'ro')
                : 'n/a' }}</p>
        </div>
    </ng-container>
</div>